// The Purpose is to start moving important code here that will be added to kb4-scorm-runtime
// We can start moving:
// 1. GetAccountInfo routine (from training.vue to here)
// 2. GetTheme routine (from training.vue to here)
// The major milestones would be to move `ThemeConf`, but the usage of the store is very spread around the code
import Scorm from '@bob-the-builder/kb4-scorm-client';
import ScormOptions from '@bob-the-builder/kb4-scorm-client/dist/tsc/src/types/ScormOptions';
import BTB_CONF from '@/btb-conf.json';
import { BtbConf } from '@/types/BtbConf';
import METADATA from '@/metadata.json';
import { Metadata } from '@/types/Metadata';


export default class kb4ScormClientHelper {
  private static scormLib: Scorm
  BTB_CONF: BtbConf = BTB_CONF;
  METADATA: Metadata = METADATA;

  static scorm(): Scorm{
    if(!this.scormLib) {
      this.scormLib = new Scorm();
      this.scormLib.init(this.getScormOptions()); 
    }
    return this.scormLib;
  }

  static getScormOptions() :ScormOptions{
    return ({
      metadataScormResultFormat: METADATA.scorm_result_format || '',
      playerVersion: BTB_CONF.playerInfo.version,
      debug: BTB_CONF.debug ?? false,
      scormless: BTB_CONF.scormless ?? false,
      defaultPassingScore: BTB_CONF.passingScore,
    });
  }

  static isMobileApp(): boolean{
    return this.scorm().getClientInfo() === 'mobile-app';
  }

}